export default class PersonDataProvider {
  constructor(person) {
    this.person = person;
  }


  get fullName() {
    return [
      this.person?.name,
      this.person?.surname,
    ]
      .filter((name) => name)
      .join(' ');
  }


  get companyName() {
    return this.person?.company?.name || '';
  }


  get companyNip() {
    return this.person?.company?.nip || null;
  }


  get companyOrFullName() {
    const company = this.companyName;
    const fullName = this.fullName;

    return company || fullName;
  }
}
